module.exports = __webpack_public_path__ + "img/live_01.70fb3f9b.png";